<script setup>
import { ref, computed } from 'vue'
import { useNewsStore } from '@stores/news'
import Select from '@components/global/forms/Select.vue'
import ArticleCard from '@components/news/ArticleCard.vue'
import TransitionNumber from '@components/global/transitions/TransitionNumber.vue'

const newsStore = useNewsStore()
const articles = computed(() => newsStore.articles ?? [])

const categories = ref([
	{
		name: 'Technology',
		slug: 'technology',
	},
	{
		name: 'Industry',
		slug: 'industry',
	},
	{
		name: 'Esports',
		slug: 'esports',
	},
	{
		name: 'Hardware',
		slug: 'hardware',
	},
	{
		name: 'Mobile',
		slug: 'mobile',
	},
	{
		name: 'Culture',
		slug: 'culture',
	},
])
const activeCategories = ref([])

const filteredArticles = computed(() => {
	return articles.value.filter((article) => {
		return activeCategories.value.length === 0 || activeCategories.value.includes(article.category.slug)
	})
})

const articlesWrapper = ref()
const resetScroll = () => {
	const delta = articlesWrapper.value.getBoundingClientRect().top + window.scrollY - 175
	window.scrollTo({ top: delta, behavior: 'smooth' })
}
</script>

<template>
	<section class="relative bg-crowns-off-black pb-16" v-if="articles?.length">
		<div class="container">
			<div class="sticky top-0 z-20 mb-5 flex flex-col gap-2 bg-crowns-off-black py-4 pt-24 md:flex-row md:gap-8">
				<div class="flex items-center gap-2">
					<h1 class="font-alternate-gothic text-4xl uppercase">Articles</h1>
					<div class="flex h-10 w-10 items-center justify-center rounded-full bg-crowns-off-white text-xl font-semibold text-crowns-off-black">
						<TransitionNumber :number="filteredArticles.length" />
					</div>
				</div>
				<div class="border-r border-crowns-grey"></div>
				<div class="flex items-center gap-3 whitespace-nowrap text-white">
					<div class="mr-3 whitespace-nowrap font-light">Filter By</div>
					<Select placeholder="Categories" :options="newsStore.categories" v-model="activeCategories" @change="resetScroll()" />
				</div>
			</div>
			<div class="flex grid-cols-2 flex-col gap-14 xl:grid" ref="articlesWrapper">
				<div class="h-[100%]">
					<div class="sticky top-44">
						<Transition name="fade" mode="out-in">
							<ArticleCard featured v-if="filteredArticles?.length" :article="filteredArticles[0]" :key="filteredArticles[0].slug" />
						</Transition>
					</div>
				</div>
				<div class="relative">
					<TransitionGroup name="list" tag="div">
						<ArticleCard class="[&:not(:last-child)]:mb-8 md:[&:not(:last-child)]:mb-12 xl:[&:not(:last-child)]:mb-20" v-for="(article, i) in filteredArticles.slice(1)" :article="article" :right="i % 2 === 0" :key="article.slug" />
					</TransitionGroup>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
.list-leave-active {
	@apply absolute;
}
</style>
